import {useParams} from "react-router-dom";
import {PageStandard} from "../utils/PageStandard";
import {Button, FormControl, FormLabel, Input, Stack, Textarea, Typography} from "@mui/joy";
import {useEffect, useState} from "react";
import {getPlayers, sendEmails, sendPushNotifications} from "../utils/ViewModel";


export function SendPushNotifications() {
    const { id } = useParams<{ id: string }>();
    const [recipients, setRecipients] = useState<string[]>([]);
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(id) {
            getPlayers(id)
                .then((res) => {
                    if (res) {
                        const players = res.players.map(a => a.user_id)
                        setRecipients(players);
                    }
                })
                .catch((err) => alert("Errore nel recupero dei partecipanti: " + err.message));
        }
    }, []);

    const handleSendNotifications = async () => {
        if (!id) return;
        setLoading(true)
        try {
            const result = await sendPushNotifications(recipients, title, desc);

            alert(
                `✅ Notifiche inviate con successo`
            );
            setLoading(false)
        } catch (err: any) {
            alert(`❌ Errore durante l'invio delle notifiche: ${err.message}`);
            setLoading(false)
        }
    };

    return (
        <PageStandard title="Invia Notifiche Push"
                      sidebarVisible={true}
                      headerEnd={
                          <Stack direction="row" spacing={3} alignItems="center">
                              <Typography fontFamily="monospace" level="body-sm">
                                  ID: {id}
                              </Typography>
                          </Stack>
                      }
        >
            <Stack direction="column" spacing={3}>
                <Typography>Destinatari: {recipients.length}</Typography>
                <FormControl>
                    <FormLabel>Titolo notifica</FormLabel>
                    <Input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
                </FormControl>
                <FormControl>
                    <FormLabel>Testo notifica</FormLabel>
                    <Textarea value={desc} onChange={(e) => setDesc(e.target.value)} minRows={4} />
                </FormControl>
                <Button
                    disabled={recipients.length == 0 || title.trim().length == 0 || desc.trim().length == 0 || loading}
                    onClick={handleSendNotifications}
                >
                    Invia notifica
                </Button>
            </Stack>
        </PageStandard>
    )
}